export default __webpack_public_path__ + "static/media/menu.61dad5ff.svg";